/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_RestartInputs */

const en_us2_clubs_restart = /** @type {(inputs: Clubs_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restart with the same people`)
};

const pt_br2_clubs_restart = /** @type {(inputs: Clubs_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiniciar com as mesmas pessoas`)
};

const es_419_clubs_restart = /** @type {(inputs: Clubs_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiniciar con las mismas personas`)
};

const pt_pt2_clubs_restart = /** @type {(inputs: Clubs_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomeçar com as mesmas pessoas`)
};

const fr_fr2_clubs_restart = /** @type {(inputs: Clubs_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relancer avec les mêmes personnes`)
};

const de_de2_clubs_restart = /** @type {(inputs: Clubs_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit denselben Leuten neu starten`)
};

const it_it2_clubs_restart = /** @type {(inputs: Clubs_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricomincia con le stesse persone`)
};

/**
* | output |
* | --- |
* | "Restart with the same people" |
*
* @param {Clubs_RestartInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_restart = /** @type {((inputs?: Clubs_RestartInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_RestartInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_restart(inputs)
	if (locale === "es-419") return es_419_clubs_restart(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_restart(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_restart(inputs)
	if (locale === "de-DE") return de_de2_clubs_restart(inputs)
	if (locale === "it-IT") return it_it2_clubs_restart(inputs)
	return en_us2_clubs_restart(inputs)
});
export { clubs_restart as "clubs.restart" }